import CheckoutValutec from './CheckoutValutec'

export default CheckoutValutec
